import api from "./apiClient";

export async function Delete(userId) {
	const response = await api.delete(`/users/${userId}`);
	return response;
}

export async function DeleteCohort(uniqueIds) {
	if (uniqueIds.length > 1) {
		// Delete multiple cohorts
		const deletePromises = uniqueIds.map(id => 
			api.delete(`/cohorts/${id}`)
				.then(r => r.json())
				.catch(r => Promise.reject(r))
		);
		return Promise.all(deletePromises);
	} else {
		// Delete single cohort
		const response = await api.delete(`/cohorts/${uniqueIds}`);
		return response.json();
	}
}

export async function DeletePublisher(publisherId) {
	const response = await api.delete(`/publisher/${publisherId}`);
	return response;
}

export async function DeleteTag(tagId) {
	const response = await api.delete(`/tags/${tagId}`);
	return response;
}